import { supabase } from '@/lib/supabase/config';
import { handleError } from '@/shared/utils/error-handling';

interface AssignAddonInput {
  projectId: number;
  addonId: string;
}

export async function assignAddon(input: AssignAddonInput): Promise<void> {
  const { error } = await supabase.rpc('assign_addon_to_project', {
    p_project_id: input.projectId,
    p_addon_id: input.addonId,
  });

  if (error) {
    const appError = await handleError(error);
    throw appError;
  }
}
